/* Copyright 2015-2019 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "../form/PushButton",
    "../mixins/property/IconMixin",
    "../mixins/property/QuickAccessIconMixin",
    "../mixins/QabWidgetMixin"
], function (declare, PushButton, IconMixin, QuickAccessIconMixin, QabWidgetMixin) {

    return declare([PushButton, IconMixin, QuickAccessIconMixin, QabWidgetMixin], {
    });
});